
class Filters extends HTMLElement {
    constructor() {
        super()
        this.handleSize()
        window.addEventListener("resize", () => this.handleSize())
    }

    handleSize() {
        const btn = document.querySelector("#Filter_Mobile_btn");
        const container = document.querySelector("#Filter_Container");
        if (!btn || !container) return;

        // expose mobile_nav height as a CSS variable so the drawer / trigger can
        // position above the bottom nav reliably
        const bottomBar = document.getElementById("mobile_nav");
        const bottomBarHeight = bottomBar?.clientHeight || 60;
        document.documentElement.style.setProperty("--mobile-nav-height", `${bottomBarHeight}px`);

        if (window.innerWidth > 750) {
            container.classList.remove("ml_filter_hide");
            document.body.classList.remove("ml_fix_body");
            btn.querySelector(".ml_filter_collapser_arrow")?.classList.remove("ml_rotate_arrow_filter");
            return;
        }

        // start hidden on mobile if not already toggled
        if (!container.dataset.mobileInit) {
            container.classList.add("ml_filter_hide");
            container.dataset.mobileInit = "1";
        }

        btn.onclick = () => {
            container.classList.toggle("ml_filter_hide");
            document.body.classList.toggle("ml_fix_body", !container.classList.contains("ml_filter_hide"));
            btn.querySelector(".ml_filter_collapser_arrow")?.classList.toggle("ml_rotate_arrow_filter");
        };
    }

    toggle() {
        const filter = document.getElementById(this.id)
        const filterBody = filter.getElementsByClassName('ml_filter_body')?.[0]
        const filterIcon = filter.getElementsByClassName('ml_filter_icon')?.[0]
        filterBody.classList.toggle('expand')
        filterBody.style.height = filterBody.classList.contains('expand') ? filterBody.scrollHeight + 'px' : 0
        filterIcon.classList.toggle('expand_icon')
    }
}

customElements.define('ml-filters', Filters);
